export const tv = {
  name: "tv" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M1.6 5.5a.9.9 0 0 1 .9-.9h19a.9.9 0 0 1 .9.9V17a.9.9 0 0 1-.9.9h-5a.9.9 0 1 1 0-1.8h4.1V6.4H3.4v9.7H12a.9.9 0 0 1 .523.168l3.5 2.5a.9.9 0 0 1-1.046 1.464L12 18.106l-2.977 2.126a.9.9 0 0 1-1.046-1.464l1.215-.868H2.5a.9.9 0 0 1-.9-.9V5.5Z" clip-rule="evenodd"/></svg>`,
  keywords: ["tv"],
  category: "device" as const,
};
